export type KitchenStaffRole = 'HEAD_KITCHEN' | 'ASSISTANT_HEAD_KITCHEN' | 'STAFF_KITCHEN'

export type KitchenStaffMember = {
  id: string
  name: string
  role: KitchenStaffRole
  roleLabel: string
  shiftStart: string
  shiftEnd: string
}

/** Staff yang boleh absen di satu dapur (tablet/shared device). */
export const KITCHEN_STAFF_ROSTER: KitchenStaffMember[] = [
  {
    id: 'user-kitchen-1',
    name: 'Andi Wijaya',
    role: 'HEAD_KITCHEN',
    roleLabel: 'Kepala dapur',
    shiftStart: '06:00',
    shiftEnd: '14:00',
  },
  {
    id: 'user-kitchen-2',
    name: 'Budi Santoso',
    role: 'STAFF_KITCHEN',
    roleLabel: 'Koki',
    shiftStart: '06:00',
    shiftEnd: '14:00',
  },
  {
    id: 'user-kitchen-3',
    name: 'Siti Rahma',
    role: 'STAFF_KITCHEN',
    roleLabel: 'Helper',
    shiftStart: '07:00',
    shiftEnd: '15:00',
  },
  {
    id: 'user-kitchen-4',
    name: 'Rudi Hartono',
    role: 'STAFF_KITCHEN',
    roleLabel: 'Helper',
    shiftStart: '07:00',
    shiftEnd: '15:00',
  },
]

/** Mock PIN per orang — di produksi PIN mengidentifikasi user, bukan sesi device. */
const MOCK_STAFF_PINS: Record<string, string> = {
  'user-kitchen-1': '123456',
  'user-kitchen-2': '111111',
  'user-kitchen-3': '222222',
  'user-kitchen-4': '333333',
}

export function getKitchenStaffMember(userId: string): KitchenStaffMember | undefined {
  return KITCHEN_STAFF_ROSTER.find((member) => member.id === userId)
}

export function validateStaffPin(userId: string, pin: string): boolean {
  return MOCK_STAFF_PINS[userId] === pin
}

export function getStaffRoleMeta(staff: KitchenStaffMember): {
  icon: string
  chipClass: string
} {
  if (staff.role === 'HEAD_KITCHEN') {
    return {
      icon: 'supervisor_account',
      chipClass: 'bg-primary-container text-on-primary-container border border-primary-fixed-dim',
    }
  }
  if (staff.role === 'ASSISTANT_HEAD_KITCHEN') {
    return {
      icon: 'support_agent',
      chipClass: 'bg-primary-container text-on-primary-container border border-primary-fixed-dim',
    }
  }
  if (staff.roleLabel === 'Koki') {
    return {
      icon: 'restaurant',
      chipClass: 'bg-surface-container text-on-surface-variant border border-outline-variant',
    }
  }
  return {
    icon: 'handyman',
    chipClass: 'bg-secondary-fixed text-on-secondary-fixed-variant border border-secondary-fixed-dim',
  }
}
